import React from 'react'
import styled from 'styled-components'
import EditIcon from '@mui/icons-material/Edit'
import { color } from 'styles/colors'
import { screenSize } from 'styles/shared'
import Table from 'components/Table'
import Resource, { ValidResourceTypes } from 'types/Resource'

type ResourceProps = {
  type: ValidResourceTypes
  resource: Resource
}
type Props = {
  type: ValidResourceTypes
  resource: Resource
  onSuccessfulSubmission: () => void
  onClickEditResource:(val:ResourceProps)=>void
}

const PublishedCell = ({ type, resource, onClickEditResource }: Props) => {
  return (
    <S.TableCell>
      <div>
        <S.SmallScreenLabel>Published Status:</S.SmallScreenLabel>
        <S.Status draft={resource.draft}>{!resource.draft ? 'Published' : 'Not Published'}</S.Status>
        <S.EditIcon
          fontSize="small"
          color="primary"
          style={{ cursor: 'pointer' }}
          aria-label={`Edit Resource with title: ${resource.name}`}
          onClick={() => { onClickEditResource({ resource, type }) }}
        >
          Edit
        </S.EditIcon>
      </div>
    </S.TableCell>
  )
}

export default PublishedCell

const S = {
  TableCell: styled(Table.Cell)`
    padding: 15px;
  `,
  SmallScreenLabel: styled.div`
    display: none;
    font-weight: bold;

    @media ${screenSize.small} {
      display: block;
      padding-right: 10px;
    }
  `,
  EditIcon: styled(EditIcon)`
      color: ${color('EditIcon')};
      margin-left: 10px;
    `,
  Status: styled.div.withConfig({
    shouldForwardProp: (prop) => !['draft'].includes(prop)
  })<{ draft }>`
    display: inline-block;
    padding: 4px 10px;
    margin-bottom: 5px;
    text-align: center;
    font-size: 12px;
    letter-spacing: 0;
    text-transform: uppercase;
    border: 1px solid ${color('border')};
    border-radius: 14px;
  
    ${({ draft }) => {
    if (!draft) {
      return `
        border-color: ${color('siteMessageEnabledStatusBorder')};
        background-color: ${color('positiveStatus')};
        color: ${color('siteMessageStatusEnabledText')};
      `
    } else {
      return ` 
        color: ${color('statusDisabledText')};
      `
    }
  }}`
}
